import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

/** Shared MUI DataGrid sx for CRM light/dark theme (headers, rows, footer). */
export const profaseDataGridSx: SystemStyleObject<Theme> = {
  border: '1px solid var(--crm-grid-border)',
  backgroundColor: 'var(--crm-grid-bg)',
  color: 'var(--crm-body-text)',
  '--DataGrid-containerBackground': 'var(--crm-grid-bg)',
  '--DataGrid-pinnedBackground': 'var(--crm-grid-bg)',
  '--DataGrid-headerBackground': 'var(--crm-grid-header-bg)',
  '& .MuiDataGrid-main, & .MuiDataGrid-virtualScroller, & .MuiDataGrid-virtualScrollerContent, & .MuiDataGrid-virtualScrollerRenderZone': {
    backgroundColor: 'var(--crm-grid-bg)',
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: 'var(--crm-grid-header-bg)',
    color: 'var(--crm-grid-header-text)',
    borderBottom: '1px solid var(--crm-grid-border)',
  },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: 'var(--crm-grid-header-bg)',
    color: 'var(--crm-grid-header-text)',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    color: 'var(--crm-grid-header-text)',
    fontWeight: 600,
  },
  '& .MuiDataGrid-columnHeadersInner': {
    backgroundColor: 'var(--crm-grid-header-bg)',
  },
  '& .MuiDataGrid-sortIcon, & .MuiDataGrid-menuIcon, & .MuiDataGrid-columnHeader .MuiIconButton-root, & .MuiDataGrid-columnHeader--sorted .MuiDataGrid-sortIcon': {
    color: 'var(--crm-grid-header-accent)',
  },
  '& .MuiDataGrid-columnHeader--sorted, & .MuiDataGrid-columnHeader--sorted .MuiDataGrid-columnHeaderTitle': {
    color: 'var(--crm-grid-header-text)',
  },
  '& .MuiDataGrid-cell': {
    borderColor: 'var(--crm-grid-border)',
    color: 'var(--crm-grid-cell-text)',
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: 'var(--crm-grid-row-hover)',
  },
  '& .MuiDataGrid-footerContainer': {
    backgroundColor: 'var(--crm-grid-header-bg)',
    borderTop: '1px solid var(--crm-grid-border)',
    color: 'var(--crm-text-secondary)',
  },
  '& .MuiTablePagination-root, & .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
    color: 'var(--crm-text-secondary)',
  },
  '& .MuiTablePagination-select': {
    color: 'var(--crm-text-primary)',
  },
  '& .MuiIconButton-root': {
    color: 'var(--crm-text-secondary)',
  },
  '& .MuiDataGrid-columnSeparator': {
    color: 'var(--crm-grid-border)',
  },
  '& .MuiDataGrid-overlay': {
    backgroundColor: 'var(--crm-grid-bg)',
    color: 'var(--crm-text-secondary)',
  },
  '& .MuiDataGrid-cell:focus': { outline: 'none' },
  '& .MuiDataGrid-cell:focus-within': { outline: 'none' },
};
